export namespace Data {
  export const NONE: (input: void | undefined) => undefined = () => undefined

  export function asIs<T>() {
    return (input: T): T => input
  }
}
